"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./SwitchComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SwitchComponent = function SwitchComponent(props) {
  return /*#__PURE__*/_react["default"].createElement(_antd.Switch, _extends({}, props, {
    name: props.name,
    id: props.id,
    className: "iiht-ant-switch ".concat(props.className)
  }));
};

var _default = SwitchComponent;
exports["default"] = _default;